import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActionCardComponent } from '@shared/components/action-card/action-card.component';
import { ModeloDocumento } from '@shared/services/models/dfe/modelo-documento.model';

/**
 * Seção de seleção múltipla dos modelos de documento aos quais a regra se aplica.
 * Grava um array de códigos em form.get('modelosDocumento').
 * Não é renderizada no modo padrão (a regra padrão atende todos os modelos).
 */
@Component({
    selector: 'app-regra-tributaria-modelos-documento-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatIconModule, ActionCardComponent],
    templateUrl: './regra-tributaria-modelos-documento-section.component.html',
    styleUrl: './regra-tributaria-modelos-documento-section.component.css',
})
export class RegraTributariaModelosDocumentoSectionComponent {
    @Input({ required: true }) form!: FormGroup;
    @Input() modelos: ModeloDocumento[] = [];
    @Input() isModoPadrao = false;

    public get modelosControl(): FormControl {
        return this.form.get('modelosDocumento') as FormControl;
    }

    public isSelecionado(codigo: string | null): boolean {
        if (!codigo) {
            return false;
        }
        const atual: string[] = this.modelosControl?.value ?? [];
        return atual.includes(codigo);
    }

    public toggle(codigo: string | null): void {
        if (!codigo) {
            return;
        }
        const atual: string[] = [...(this.modelosControl?.value ?? [])];
        const idx = atual.indexOf(codigo);
        if (idx >= 0) {
            atual.splice(idx, 1);
        } else {
            atual.push(codigo);
        }
        this.modelosControl.setValue(atual);
        this.modelosControl.markAsDirty();
    }
}
